import { createSlice } from '@reduxjs/toolkit';
import type { ApiErrorBody, PanelEventReportListDto } from '@icebreaker/shared';
import { createAsyncActions } from '@icebreaker/shared/store';

/**
 * KURUMUN ETKİNLİK RAPORLARI ÖZETİ (organizatör raporu Story 5, tasarım kare 5).
 *
 * Salt okunur bir dal: panel raporu değiştirmez, mutasyonu yoktur, bu yüzden
 * invalidation kalemi de yoktur. Kurum değişince eski kurumun satırları atılır
 * (kurumdan kuruma geçişte başka kurumun sayısı bir an bile görünmez).
 */
export const fetchOrganizationReports = createAsyncActions<
  { organizationId: string },
  PanelEventReportListDto
>('panelOrgReports/listFetch');

type Phase = 'idle' | 'loading' | 'succeeded' | 'failed';

export interface OrganizationReportsState {
  organizationId: string | null;
  data: PanelEventReportListDto | null;
  phase: Phase;
  error: ApiErrorBody | null;
}

const initialState: OrganizationReportsState = {
  organizationId: null,
  data: null,
  phase: 'idle',
  error: null,
};

const slice = createSlice({
  name: 'panelOrgReports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationReports.request, (state, action) => {
        if (state.organizationId !== action.payload.organizationId) state.data = null;
        state.organizationId = action.payload.organizationId;
        state.phase = 'loading';
        state.error = null;
      })
      .addCase(fetchOrganizationReports.success, (state, action) => {
        state.phase = 'succeeded';
        state.data = { ...action.payload, items: action.payload.items.map((row) => ({ ...row })) };
      })
      .addCase(fetchOrganizationReports.failure, (state, action) => {
        state.phase = 'failed';
        state.error = action.payload;
      });
  },
});

export const organizationReportsReducer = slice.reducer;
